import React, { useContext, useEffect, useState } from "react";
import baseUrl from "../../utils/baseUrl";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { DataContext } from "../../context/DataContext";
import ReactGA from "react-ga";
import { getPrice } from "../../service/getPrice";
import { Toaster, toast } from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";
import SessionManager from "../../utils/SessionManager";
import { ReactComponent as LogoSVG } from "../../assets/icons/eliteVacances.svg";

import VideoBackground from "../../assets/videos/login_background.mp4";

import "../../styles/login.css";

const INITIAL_USER = {
  contrato: "",
  password: "",
};

const Signin = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(INITIAL_USER);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { setData } = useContext(DataContext);
  const [captchaResponse, setCaptchaResponse] = useState("");
  const keyCaptcha = "6LfEe7QmAAAAAKPiHe16j9vqFfEjKZoCpUdjInMd";

  const invalidFormatRegex = /^[A-Z]{3}-/;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); //Google Analytics
    setData(null);
    const isExpired = localStorage.getItem("token");

    if (isExpired) {
      setTimeout(() => {
        navigate("/home");
      }, "0");
    }
  }, [setData, navigate]);
  useEffect(() => {
    var obj = document.getElementById("body");
    obj.style.removeProperty("overflow");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "contrato") {
      if (value.length > 10) return; // Limita a 10 caracteres

      const upperValue = value.toUpperCase();
      setUser((prevState) => ({ ...prevState, [name]: upperValue }));

      // Validación del formato NO permitido
      setError(
        invalidFormatRegex.test(upperValue)
          ? "Formato de contrato no válido"
          : null,
      );
    } else {
      setUser((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaResponse) {
      toast.error("Por favor, completa el reCAPTCHA");
      return;
    }
    ReactGA.event({
      category: "Pagina de inicio",
      action: "Sistema de autenticación priority",
      label: "Notificación solcitud inicio de sesión",
      value: 1,
    });
    setLoading(true);
    try {
      const url = `${baseUrl}/api/users/getuser`;
      const payload = { ...user };
      const response = await axios.post(url, payload, {
        header: "Content-Type Aplication/json",
      });
      if (response.data.status === 500) {
        toast.error("Usuario o contraseña Incorrectos, Intente Nuevamente", {
          style: {
            border: "none",
            borderBottom: "5px solid #ed0a26",
            color: "#ed0a26",
          },
          position: "top-center",
        });
      } else {
        localStorage.setItem("token", response.data.token);
        const response_price = await getPrice();
        if (response_price.url !== false) {
          sessionStorage.setItem("priceURL", response_price);
        }
        new SessionManager(2400000);
        navigate("/home");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRecaptchaChange = (response) => {
    setCaptchaResponse(response);
  };

  return (
    <main className="container-fluid bg-login">
      <video
        className="login-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={VideoBackground} type="video/mp4" />
        Tu navegador no soporta videos HTML5.
      </video>

      {/* Capa oscura/degradado sobre el video */}
      <div className="login-video-overlay"></div>

      <div className="login-content">
        <Toaster />

        <section className="mt-5 centrar bg-degrade">
          <div className="container mt-5">
            <div className="row d-flex justify-content-center align-items-center mt-5">
              <div className="col col-xl-4">
                <div className="Mycard">
                  <div className="centrar">
                    <LogoSVG className="bg-logo-navbar" width={120} />
                  </div>

                  <form onSubmit={handleSubmit} className="mt-4">
                    <div className="inputGac">
                      <input
                        type="text"
                        placeholder="Digite su contrato"
                        name="contrato"
                        value={user.contrato}
                        onChange={handleChange}
                        maxLength={10}
                      />

                      <label htmlFor="contrato">Usuario</label>

                      {error && <p className="error-formato">{error}</p>}
                    </div>

                    <div className="inputGac">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Digite su contraseña"
                        name="password"
                        value={user.password}
                        onChange={handleChange}
                        required
                      />

                      <label htmlFor="password">Contraseña</label>

                      {showPassword ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 28 28"
                          className="icon_password"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {/* Tu SVG actual */}
                        </svg>
                      ) : (
                        <svg
                          className="icon_password"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 28 28"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {/* Tu SVG actual */}
                        </svg>
                      )}
                    </div>

                    <div className="centrar mt-4">
                      <ReCAPTCHA
                        sitekey={keyCaptcha}
                        onChange={handleRecaptchaChange}
                        style={{
                          borderRadius: ".3rem",
                        }}
                      />
                    </div>

                    <button
                      className="mt-3 btn-login"
                      disabled={loading || error}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm"></span>{" "}
                          Cargando...
                        </>
                      ) : (
                        "Iniciar Sesión"
                      )}
                    </button>

                    <NavLink
                      to="/accounts/password/reset"
                      className="note centrar mt-3 text-ancor-tand"
                    >
                      ¿Has olvidado la contraseña?
                    </NavLink>

                    <div className="centrar">
                      <a
                        className="text-ancor-tand note"
                        href="https://api.whatsapp.com/send?phone=5717945996&text=Buen%20d%C3%ADa%20%20%0ARequiero%20ayuda%20para%20ingresar%20al%20portal%20de%20clientes%20afiliados"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        ¿Necesitas ayuda?
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Signin;
